import React from 'react';
import { useTranslate } from '@tolgee/react';
import InventorySection from './InventorySection';
import LivePricesSection from './LivePricesSection';
import LeaderBoardSection from './LeaderboardSection';

const RightBox = () => {
  const { t } = useTranslate('commandCenter');
  return (
    <div className='w-[200px] h-[calc(100vh-80px)] hidden sticky lg:flex flex-col left-0 top-[70px] gap-y-2'>
      <div className='h-[345px] bg-[#3C3B3B] bg-opacity-40 rounded-[10px] w-full p-[10px] flex flex-col min-h-[200px] 2xl:min-h-[345px] relative'>
        {/* <div
          className='absolute top-0 left-0 w-full h-full z-[2] rounded-[10px] flex justify-center items-center text-center backdrop-blur-sm  '
          // style={{ background: 'linear-gradient(0deg, rgba(151,151,151,0.5) 0%, rgba(151,151,151,0) 100%)' }}
        >
          <Typography className='px-2' size='s12ToS12'>
            {t('CENTER_SECTION.achievementSection.activeCommander.description')}
          </Typography>
        </div> */}
        <LivePricesSection />
      </div>

      <div className='bg-[#3C3B3B] bg-opacity-40 rounded-[10px] h-[270px] min-h-[250px] p-[10px] flex flex-col relative'>
        <LeaderBoardSection />
      </div>

      <div className='bg-[#3C3B3B] bg-opacity-40 rounded-[10px] h-[calc(100%-600px)] min-h-[250px] p-[10px] flex flex-col'>
        <InventorySection />
      </div>
    </div>
  );
};

export default RightBox;
